import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as MoreIcon } from "../../assets/images/MoreSquare1.svg";
import { ReactComponent as iIcon } from "../../assets/images/iIcon.svg";
import { ReactComponent as InfoSquare } from "../../assets/images/InfoSquare1.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllOrganisation,
  getOrganisationMaster,
} from "../../reduxSlices/organisationSlice";
import {
  BASE_URL,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  toastConfig,
} from "../../constants/constant";
import { IconButton, Typography } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Loader from "../../components/loader/Loader";
import { setHeader } from "../../reduxSlices/headerSlice";
import ContentLoader from "../../components/loader/ContentLoader";
import debounce from "lodash.debounce";
import { useCallback } from "react";
import SearchBar from "../../components/searchBar/SearchBar";
import CommonDropdown from "../../components/dropdown/CommonDropdown";
import TopBar from "../../components/topbar/TopBar";
import { getAllUsers } from "../../reduxSlices/userSlice";
import {
  getAllPackage,
  getPackageMaster,
  getReportMaster,
} from "../../reduxSlices/packageSlice";
import ActionDropdown from "../../components/dropdown/ActionDropdown";
import { toast } from "react-toastify";
import { Service } from "../../services/service";
import CommonDialog from "../../components/dialog/CommonDialog";
import NoResultFound from "../../components/noResultFound/NoResultFound";

const service = new Service();

const columns = [
  { id: "name", label: "Name", minWidth: 170, align: "left" },
  { id: "reports", label: "Reports", minWidth: 170, align: "left" },
  {
    id: "organisations",
    label: "Organisations",
    minWidth: 170,
    align: "left",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 170,
    align: "left",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "center",
  },
];

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom-end" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f5",
    opacity: 0.1,
    color: "#000",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    maxWidth: "auto",
  },
}));

export default function PackagePage() {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [id, setId] = useState(null);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const allPackage = useSelector((state) => state.package.allPackage);
  const loading = useSelector((state) => state.package.loading);
  const headerData = useSelector((state) => state.header);
  const searchInput = headerData.searchInput;
  const organisationsValue = headerData.organisationsValue;
  const reportsValue = headerData.reportsValue;
  const userRole = useSelector((state) => state?.user?.userRoleId);
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID) ? true : false;

  const reportMaster = useSelector((state) => state.package.reportMaster);
  const organisationMaster = useSelector(
    (state) => state.organization.organisationMaster
  );
  const reportOptions = reportMaster?.map((item, i) => item.reportName);
  const organisationOptions = organisationMaster?.map(
    (item, i) => item.organizationName
  );

  const handleMoreIcon = (event, data) => {
    console.log("event", event);
    setAnchorEl(event.currentTarget);
    setId(data?.packageId);
    setData(data);
  };

  const getPackageData = async () => {
    const obj = {
      searchText: searchInput || "",
      organization: organisationsValue || [],
      report: reportsValue || [],
    };
    await dispatch(getAllPackage(obj));
  };

  useEffect(() => {
    dispatch(
      setHeader({
        page: "packages",
        title: "Packages",
        subTitle:
          "Here is the list of all the subscription packages along with their details",
      })
    );
    dispatch(getReportMaster());
    dispatch(getOrganisationMaster());
  }, []);

  useEffect(() => {
    getPackageData();
  }, [dispatch]);

  const getPackageDataWithDebounce = debounce(() => {
    getPackageData();
  }, 500);

  const organisationValueDebounceLoadData = useCallback(
    debounce(getPackageDataWithDebounce, 500),
    [organisationsValue]
  );

  const reportsValueDebounceLoadData = useCallback(
    debounce(getPackageDataWithDebounce, 500),
    [reportsValue]
  );

  const searchInputDebounceLoadData = useCallback(
    debounce(getPackageDataWithDebounce, 500),
    [searchInput]
  );

  useEffect(() => {
    searchInputDebounceLoadData();

    return searchInputDebounceLoadData.cancel;
  }, [searchInput, searchInputDebounceLoadData]);

  useEffect(() => {
    organisationValueDebounceLoadData();

    return organisationValueDebounceLoadData.cancel;
  }, [organisationsValue, organisationValueDebounceLoadData]);

  useEffect(() => {
    reportsValueDebounceLoadData();

    return reportsValueDebounceLoadData.cancel;
  }, [reportsValue, reportsValueDebounceLoadData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    if (id) {
      console.log("id>>>>>>>", id);
      deletePackage(id);
      setOpen(false);
    }
  };

  const deletePackage = async (id) => {
    let url = `/api/Package/DeletePackage?id=${id}`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let response = await service.newDeleteApi(url, {}, user_token);
      let resp = response?.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        toast.success(
          `Package marked as ${data?.isActive ? "Inactive" : "Active"}`,
          {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          }
        );
        getPackageData();
      } else {
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.message, toastConfig);
    }
  };

  return (
    <>
      <Paper
        style={{
          width: "100%",
          overflow: "hidden",
          border: "none",
          borderRadius: "12px",
          boxShadow: "none",
          paddingBottom: "32px",
        }}
      >
        <TopBar
          isVfAdmin={isVfAdmin}
          reportFilter={reportOptions}
          organisationsFilter={organisationOptions}
          placeholder="Search packages here..."
        />
        {loading && allPackage.length === 0 ? (
          <ContentLoader />
        ) : (
          <TableContainer
            style={{ maxHeight: "calc(100vh - 320px)", padding: "0 0" }}
            className="table_container"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns?.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        backgroundColor: "#fff",
                        color: "#8a8a8a",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allPackage.length > 0 ? (
                  <>
                    {allPackage?.map((elem) => (
                      <TableRow hover key={elem.organizationId}>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#282828",
                            fontWeight: 600,
                          }}
                        >
                          {elem?.packageName || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.reportsMaster?.length > 0 ? (
                            <>
                              {elem?.reportsMaster?.length} Reports
                              <CustomTooltip
                                title={elem?.reportsMaster?.map((item, inx) => (
                                  <Typography
                                    key={inx}
                                    sx={{
                                      fontSize: "12px",
                                      fontFamily: "Montserrat",
                                      color: "#5a5a5a",
                                    }}
                                  >
                                    {item?.reportName}
                                  </Typography>
                                ))}
                              >
                                <IconButton>
                                  <InfoSquare />
                                </IconButton>
                              </CustomTooltip>
                            </>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.organizations?.length > 0 ? (
                            <>
                              {elem?.organizations?.length} Organisations
                              <CustomTooltip
                                title={elem?.organizations?.map((item, inx) => (
                                  <Typography
                                    key={inx}
                                    sx={{
                                      fontSize: "12px",
                                      fontFamily: "Montserrat",
                                      color: "#5a5a5a",
                                    }}
                                  >
                                    {item?.organizationName}
                                  </Typography>
                                ))}
                              >
                                <IconButton>
                                  <InfoSquare />
                                </IconButton>
                              </CustomTooltip>
                            </>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.isActive ? "Active" : "Inactive"}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          align="center"
                        >
                          <MoreIcon onClick={(e) => handleMoreIcon(e, elem)} />
                        </TableCell>
                      </TableRow>
                    ))}
                    <ActionDropdown
                      anchorEl={anchorEl}
                      setAnchorEl={setAnchorEl}
                      editNavigate={`/edit-package/${id}`}
                      setOpen={setOpen}
                      isDelete={false}
                      isActive={true}
                      text={`Mark as ${data?.isActive ? "Inactive" : "Active"}`}
                      markAsActiveInactive={handleDelete}
                    />
                  </>
                ) : (
                  <NoResultFound
                    description="We couldn’t find any matches for search query or applied filter. Please try different
                  keyword or filters."
                  />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      {/* <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleDelete}
        title="Confirm delete"
        subTitle={`Are you sure you want to delete <span style="font-weight: 700;">${data?.packageName}</span> as a package? You’ll not be able to reverse this action.`}
        leftButtonText="Cancel"
        rightButtonText="Delete"
      /> */}
    </>
  );
}
